<template>
  <div>
    <div
      style="display: inline-block"
      class="q-mr-sm"
      v-if="data.props.row.lastMessageReceived"
    >
      {{ data.props.row.lastMessageReceived | momentFromNow }}
    </div>
    <q-tooltip v-if="data.props.row.lastMessageReceived">
      {{ data.props.row.lastMessageReceived | momentFormat }}
    </q-tooltip>
  </div>
</template>

<script>
  import moment from "moment";
  export default {
    props: ["data"],
    data: () => ({}),
  };
</script>
